import { CodeXml, FileBraces, Image, Type } from "lucide-react";
import React from "react";

import { IgPaper, IgTypography } from "@intelligems/ig-theme";
import { useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { GroupVariationRow } from "@src/features/experienceBuilder/modifications/copyMod/GroupVariationRow";
import { getValueSummary } from "@src/store/slices/experienceBuilder/common/utils/modSummary";
import {
  EmbeddedMod,
  OtherGroupMod,
} from "@src/store/slices/experienceBuilder/types";

interface OtherGroupModCardProps {
  selector: string;
  mods: OtherGroupMod[];
}

const getModIcon = (mod: EmbeddedMod) => {
  switch (mod.type) {
    case "text":
      return mod.editMode === "html" ? (
        <CodeXml size={16} />
      ) : (
        <Type size={16} />
      );
    case "image":
      return mod.editMode === "html" ? (
        <CodeXml size={16} />
      ) : (
        <Image size={16} />
      );
    case "injection":
      return <FileBraces size={16} />;
  }
};

export const OtherGroupModCard = ({
  selector,
  mods,
}: OtherGroupModCardProps) => {
  const theme = useTheme();

  return (
    <IgPaper sx={{ p: 1, borderRadius: "6px" }}>
      <Stack
        direction="row"
        spacing={2.5}
        alignItems="center"
        sx={{
          backgroundColor: theme.igBackgroundColors.baseLightLow,
          borderRadius: "6px",
          px: 4,
          py: 3,
        }}
      >
        {getModIcon(mods[0].mod)}
        <IgTypography variant="body1" noWrap sx={{ flex: 1 }}>
          {selector}
        </IgTypography>
      </Stack>
      <Stack>
        {mods.map((groupMod) => (
          <GroupVariationRow
            key={groupMod.variationId}
            variationName={groupMod.variationName}
            valueSummary={getValueSummary(groupMod.mod)}
            mod={groupMod.mod}
          />
        ))}
      </Stack>
    </IgPaper>
  );
};
